<div class="bg-th-yellow mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i
      class="fa fa-arrow-left text-secondary my-auto pointer text-dark"
      [routerLink]="['/']"
    ></i>

    <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
      <span class="fw-bold"> حوزه‌های خدمتی (امور) </span>
    </a>
  </div>
</div>

<main class="px-2">
  <!-- جدول اطلاعات -->
  <div class="border border-2 container-fluid row gx-0 gy-2 mt-3 p-2">
    <!-- جستجو -->

    <div class="col-8 p-1">
      <input
        type="text"
        class="w-100 form-control"
        placeholder="جستجو کنید ..."
        (input)="filterResult($event.target.value)"
      />
    </div>

    <!-- افزودن -->

    <div class="col-auto p-1">
      <button
        class="w-100 h-100 btn btn-success"
        (click)="openAddOrUpdateAreaModal()"
      >
        &nbsp; افزودن &nbsp;
      </button>
    </div>

    <!-- جدول اطلاعات -->

    <div class="section border border-2 mt-2">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col" class="">#</th>

            <th scope="col" class="">عملیات</th>

            <th scope="col" class="">عنوان امور</th>

            <th scope="col" class="">تعداد نقاط محدوده</th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="f14 text-center"
            *ngFor="let item of lst_Areas; let i = index"
          >
            <th class="text-dark">{{ i + 1 | faNum }}</th>

            <th class="">
              <i
                class="fa fa-edit fa-lg text-primary pointer mx-1"
                title="ویرایش"
                (click)="openAddOrUpdateAreaModal(item)"
              ></i>

              <i
                class="fa fa-trash fa-lg text-danger pointer"
                title="حذف"
                (click)="removeArea(item)"
              ></i>
            </th>

            <td>{{ item.strComment }}</td>

            <td>{{ (item.lstPoints ? item.lstPoints.length : 0) | faNum }}</td>
          </tr>

          <tr
            *ngIf="!lst_Areas || lst_Areas.length === 0"
          >
            <td colspan="4" class="text-center text-muted py-3">
              رکوردی برای نمایش وجود ندارد.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- افزودن / ویرایش امور -->
  <div class="modal fade" id="addOrUpdateArea_Modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title">
            {{ editMode ? 'ویرایش امور' : 'افزودن امور' }}
          </h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div [formGroup]="areaForm" class="container-fluid row gx-2 gy-2 p-2">
            <!-- عنوان -->

            <div class="position-relative col-12 p-2">
              <label class="mb-2 text-muted"> عنوان امور </label>

              <input
                class="form-control p-2 text-center"
                formControlName="strComment"
              />
            </div>

            <!-- نقشه محدوده -->

            <div class="position-relative col-12 p-2">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="mb-0 text-muted"> محدوده جغرافیایی </label>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  (click)="addInteraction()"
                >
                  ترسیم محدوده
                </button>
              </div>

              <div id="areasMap" style="height: 400px; width: 100%;"></div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-primary" (click)="submitArea()">
            ذخیره اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
